import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { OffCyclePayrollSetup } from "../../components/OffCyclePayrollSetup";

export const OffCyclePayrollSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Off-Cycle Payroll"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "OffCyclePayroll", navigateTo: "/taxes/remittance/cra" },
      ]}
      mainContents={<OffCyclePayrollSetup />}
    />
  );
};
